'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormControlFeedback = require('react-bootstrap/lib/FormControlFeedback');

var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FormControlFeedback2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/FormControlFeedback.js
// module id = 619
// module chunks = 0